'use strict';

const generalButtonDisplayBehaviorHelper = require('../../generalButtonDisplayBehavior');

const PRICE_SELECTOR = '.price .sales .value';
const CART_STATUS_UPDATE = 'cart:update';
const PAYPAL_BANNER_SELECTOR = '.js-pp-banner';

/**
 * Updates PayPal credit message amount
 * @param {Object} productData - product info after update
 * @param {Element} $creditMessage - credit message element
 * @returns {void}
 */
function updateCreditMessageAmount(productData, $creditMessage) {
    const { price, selectedQuantity } = productData.data?.product || productData;
    const productPrice = price.max?.sales?.value || price.sales.value;

    const newPrice = parseFloat(productPrice) * parseFloat(selectedQuantity);

    $creditMessage.setAttribute('data-pp-amount', newPrice);
}

/**
 * Handles PP credit messages behavior on PDP
 * @returns {void}
 */
function initPaypalCreditMessagesBehaviorOnPdp() {
    $('body').on('product:afterAttributeSelect', function(_, productData) {
        const $creditMessage = document.querySelector(PAYPAL_BANNER_SELECTOR);

        // If PayPal credit message is available, then update credit message amount
        if ($creditMessage) {
            updateCreditMessageAmount(productData, $creditMessage);
        }
    });
}

/**
 * Handles PP credit messages behavior on PDP for Product bandle
 * @returns {void}
 */
function initPaypalCreditMessagesBehaviorOnPdpBundle() {
    const $price = document.querySelector(PRICE_SELECTOR);
    const $quantitySelector = document.querySelector('.quantity-select');
    const $creditMessage = document.querySelector(PAYPAL_BANNER_SELECTOR);

    if ($creditMessage) {
        $quantitySelector.addEventListener('change', (event) => {
            const price = parseFloat($price.getAttribute('content'));
            const quantity = parseFloat(event.target.value);

            const newPrice = price * quantity;

            $creditMessage.setAttribute('data-pp-amount', newPrice);
        });
    }
}

/**
 * Handles PP credit messages behavior on PDP for Product set
 * @returns {void}
 */
function initPaypalCreditMessagesBehaviorOnPdpSet() {
    $('body').on('product:afterAttributeSelect', function(_, productData) {
        const $productIds = document.querySelectorAll('.product-id');
        const $targerProduct = Array.from($productIds).find((el) => el.textContent === productData.data.product.id);
        const $setItemContainer = $targerProduct && $targerProduct.closest('.set-item');
        const $creditMessage = $setItemContainer && $setItemContainer.querySelector(PAYPAL_BANNER_SELECTOR);

        // If PayPal credit message is available, then update credit message amount
        if ($creditMessage) {
            updateCreditMessageAmount(productData, $creditMessage);
        }
    });
}

/**
 * Update Pay Later message amount for Cart, Category pages
 * @param {Object} _ - Event data
 * @param {Object} data - Data passed by trigger
 * @returns {void}
 */
function updatePayLaterMessageAmountForCart(_, data) {
    const ppMessageEl = document.querySelector(PAYPAL_BANNER_SELECTOR);

    let total;
    let checkElementAgain;

    if ('cart' in data) {
        total = data.cart.totals.grandTotal;
    } else if ('basket' in data) {
        total = data.basket.totals.grandTotal;
        checkElementAgain = data.basket.items.length === 0;
    } else {
        total = data.totals.grandTotal;
    }

    if (checkElementAgain && !ppMessageEl) {
        return;
    }

    ppMessageEl.dataset.ppAmount = parseFloat(total.replace(/[^0-9.]/g, ''));
}

/**
 * Handles Credit messages behavior for cart/category page
 * @returns {void}
 */
function initPaypalCreditMessagesBehavior() {
    const paypalCreditBanner = document.querySelector(PAYPAL_BANNER_SELECTOR);

    if (paypalCreditBanner) {
        $('body')
            .on(CART_STATUS_UPDATE, updatePayLaterMessageAmountForCart)
            .on('count:update', updatePayLaterMessageAmountForCart);
    }
}

/**
 * @param {Promise} clientInstancePromise - Braintree client instance promise
 * @param {boolean} isVaultMode - "true" in case if VaultMode is enabled
 * @param {Object} payPalConfigurations - Object with PayPal configurations
 * @param {Array} pvpModels - array of instances for PayPalPaymentProcessing model
 * Init PayPal button display behavior on PDP.
 */
function initProductPage() {
    const PP_BUTTONS_SELECTOR = '.js-braintree-paypal-cart-button';

    const paypalCreditBanner = document.querySelector(PAYPAL_BANNER_SELECTOR);
    const isProductSet = Boolean(document.querySelector('.set-items'));
    const isProductBundle = Boolean(document.querySelector('.product-bundle'));

    if (paypalCreditBanner) {
        if (isProductSet) {
            initPaypalCreditMessagesBehaviorOnPdpSet();
        } else if (isProductBundle) {
            initPaypalCreditMessagesBehaviorOnPdpBundle();
        } else {
            initPaypalCreditMessagesBehaviorOnPdp();
        }
    }

    generalButtonDisplayBehaviorHelper.initProductPage(PP_BUTTONS_SELECTOR);
}

module.exports = {
    initProductPage,
    initPaypalCreditMessagesBehavior
};
